import { Zap, Mail } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { LINKS } from "@/i18n/translations";
import { StoreBadges } from "./StoreBadges";

export default function Footer() {
  const { t } = useLang();
  const F = t.footer;
  return (
    <footer id="descargar" className="border-t lp-hairline bg-[#0c0c0f]">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 py-14 sm:py-20">
        <div className="grid gap-10 md:grid-cols-[1.3fr_1fr_1fr]">
          <div>
            <a href="/" className="flex items-center gap-2 font-black tracking-tighter text-lg">
              <span className="grid place-items-center w-8 h-8 rounded-lg bg-[#f5a623] text-[#09090b]">
                <Zap size={18} strokeWidth={2.5} fill="currentColor" />
              </span>
              <span>
                Lightning <span className="text-[#f5a623]">POS</span>
              </span>
            </a>
            <p className="mt-4 text-sm text-[#a1a1aa] max-w-xs">{F.tagline}</p>
            <div className="mt-6">
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#71717a] mb-3">
                {F.download}
              </p>
              <StoreBadges idPrefix="footer" />
            </div>
          </div>

          <nav aria-label={F.legal}>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#71717a] mb-4">
              {F.legal}
            </p>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={LINKS.privacy}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-privacy-link"
                  className="text-[#a1a1aa] hover:text-white transition-colors"
                >
                  {F.privacy}
                </a>
              </li>
              <li>
                <a
                  href={LINKS.dataDeletion}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-data-deletion-link"
                  className="text-[#a1a1aa] hover:text-white transition-colors"
                >
                  {F.dataDeletion}
                </a>
              </li>
            </ul>
          </nav>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#71717a] mb-4">
              {F.contact}
            </p>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={`mailto:${LINKS.email}`}
                  data-testid="footer-email-link"
                  className="inline-flex items-center gap-2 text-[#a1a1aa] hover:text-white transition-colors"
                >
                  <Mail size={14} />
                  {LINKS.email}
                </a>
              </li>
              <li>
                <a
                  href={LINKS.webPos}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-webpos-link"
                  className="text-[#a1a1aa] hover:text-white transition-colors"
                >
                  {F.webPos}
                </a>
              </li>
              <li>
                <a
                  href={LINKS.demo}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-demo-link"
                  className="text-[#a1a1aa] hover:text-white transition-colors"
                >
                  {F.demo}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t lp-hairline flex flex-col sm:flex-row justify-between gap-2 text-xs text-[#71717a]">
          <p data-testid="footer-company">
            © {new Date().getFullYear()} {F.company}. {F.rights}
          </p>
        </div>
      </div>
    </footer>
  );
}
